module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/costume_02-be8a8def3127b91cfea372c519a12401.webp";